
function IsoTope(){

    this.build();

}

IsoTope.prototype.build = function(){

    if( $('.grid').length == 0 )
        return false;

    let that = this;

    that.grid = $('.grid').isotope({
        itemSelector: '.draw',
        stamp: '.stamp',
        percentPosition: true,
        masonry: {
            columnWidth: '.grid-sizer',
            gutter: '.grid-gutter',
            horizontalOrder: true
        }
    });

    let imageLoadedCpt = 0;
    $('.grid img').each(function (index, elem) {
        let self = $(elem);

        self.on('load', function(){
            imageLoadedCpt++;
            if( imageLoadedCpt === $('.grid img').length - 1 || $('.grid img').length === 1 ){
                that.resize();
            }
        }).attr("src", self.attr('src'));
    });

};

IsoTope.prototype.resize = function(){

    $('.stamp').css({
        'height' : $('.draw--first .draw-text').outerHeight(true) + 110
    });

    this.grid.isotope('layout');

};
